import DirectLoginForm from './DirectLogin'
import LoginForm from './Login'
import ResetForm from './Reset'
import ResetVerifyForm from './ResetVerify'
import ResetPasswordForm from './ResetPassword'
import InviteForm from './Invite'

export default {
    DirectLoginForm,
    LoginForm,
    ResetForm,
    ResetVerifyForm,
    ResetPasswordForm,
    InviteForm
}
